var IFRAMES = {
  linkHelp: process.env.VUE_APP_LINK_HELP,
  ContDataDashboard: 'https://datastudio.google.com/reporting/13XEX9nF4JW8NeIS-n7eX8aG5sOiiHFxk/page/352j',
  ContDlpDashboard: 'https://datastudio.google.com/open/1lLoFVPik7FkUO-VYe_iZjy17MYdWwU7t',
  ContMonitoring: {
    appengine: ['https://public.google.stackdriver.com/public/chart/7992922739320741031?drawMode=color&showLegend=true&theme=light', 'https://public.google.stackdriver.com/public/chart/15547971741750766911?drawMode=color&showLegend=true&theme=light', 'https://public.google.stackdriver.com/public/chart/6109109710688918179?drawMode=color&showLegend=true&theme=light', 'https://public.google.stackdriver.com/public/chart/1871003279236697080?drawMode=color&showLegend=true&theme=light', 'https://public.google.stackdriver.com/public/chart/3075509385837621522?drawMode=color&showLegend=true&theme=light'],
    firestore: ['https://public.google.stackdriver.com/public/chart/16526109964563853465?drawMode=color&showLegend=true&theme=light'],
    bigquery: ['https://public.google.stackdriver.com/public/chart/10802202489660768527?drawMode=color&showLegend=true&theme=light', 'https://public.google.stackdriver.com/public/chart/12551723226847884492?drawMode=color&showLegend=true&theme=light']
  }
};

// PERMISSIONS

/* LIST OF DATA FOR PERMITS */
var ROLES_LIST = {
  //* keep user and admin in the top positions
  USER: 'user',
  ADMIN: 'admin',
  PLATFORM_STEWARD: 'bi_technical_datasteward',
  ORG_DATA_STEWARD: 'org_datamgmt_lead',
  SECURITY_TECHNICAL_DATASTEWARD: 'security_technical_datasteward',
  BUSINESS_DATA_STEWARD: 'business_data_steward',
  DATAQUALITY_OPERATOR: 'dataquality_operator',
  ML_DEVELOPER: 'ml_developer',
  ML_STEWARD: 'ml_steward',
  ML_VS_VIEWER: 'ml_vs_viewer',
  ML_VS_MANAGER: 'ml_vs_manager',
  PRODUCT_OWNER: 'product_owner',
  AUDIENCE_USER: 'audience_user',
  AUDIENCE_ANALYST: 'audience_analyst',
  AUDIENCE_ADMIN: 'audience_admin',
  ATTRIBUTE_USER: 'attribute_user',
  ATTRIBUTE_SUPERVISOR: 'attribute_supervisor',
  ATTRIBUTE_ADMIN: 'attribute_admin',
  INSIGHTS_USER_SOMOS1: 'insights_user_somos1',
  INSIGHTS_SOMOS1_DATA_ENTRY_USER: 'somos1_dataentry_user',
  INSIGHTS_SOMOS1_CORP_VIEWER: 'somos1_corp_viewer',
  INSIGHTS_BUSINESS_USER: 'insights_business_user',
  INSIGHTS_SERVICE_MANAGER: 'insights_service_manager',
  INSIGHTS_ADMIN: 'insights_admin',
  COMMUNITY_MANAGER: 'community_manager',
  ASSESSMENT_USER: 'assessment_user',
  ASSESSMENT_ADMIN: 'assessment_admin',
  SERVICE_MANAGER: 'service_manager',
  DATAOPS_USER: 'dataops_user',
  CHATBOTS_USER: 'chatbots_user'
};

/* list of roles in resources (database) */
var ROLES_RESOURCE_LIST = {
  OWNER: 'owner',
  AREA_DATA_STEWARD: 'area_data_steward',
  CORP_DATA_STEWARD: 'corp_data_steward'
};
var PATTERNS_VALIDATION = {
  EMAIL: '.+@.+',
  EMAIL_OR_NULL: '(Null)|(.+@.+)',
  EMAIL_GENERAL: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
  DOMAIN: '[a-zA-Z0-9_.-]+',
  ALPHA: '[a-zA-ZáéíóúÑÁÉÍÓÚñ]+',
  MAIN_SEARCH: '^[a-zA-Z0-9áéíóúñÁÉÍÓÚÑ@ ._-]{3,100}$',
  // cantidad de elementos de busqueda
  NUMBER: '[0-9]+',
  ALPHANUMBER: '[a-zA-Z0-9_.: <>()áéíóúÑÁÉÍÓÚñ-]+',
  // 'ALPHANUMBER_SPECIAL': '^[a-zA-Z0-9_.:,() áéíóúÑÁÉÍÓÚñ-]+$',
  ALPHANUMBER_SPECIAL: '^[^;|^\r\n|^|]+$',
  ANY: '.*',
  ANY_FILL: '.+',
  NULL: 'Null',
  NOT_NULL: '(?! *Null.*).*',
  BOOLEAN: 'true|false',
  ENVIRONMENT: 'prod|dev|test'
};
var MENU_DICT = [
// orden de menu
{
  name: 'My Objects',
  key: 'menu.dp.my_objects',
  href: {
    name: 'MyTables'
  },
  link: '/tables/MyTables',
  icon: 'icon-objects',
  roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  name: 'Initial Setup',
  key: 'menu.dp.initial_setup',
  href: {
    name: 'ContInitialSetup'
  },
  icon: 'mdi-package-variant-closed',
  link: '/ContInitialSetup',
  hidden: false,
  highlight: true,
  roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  href: {
    name: 'ContObjectSearch'
  },
  roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  href: {
    name: 'ContLineageIframes'
  },
  roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  name: 'My Pendings',
  key: 'menu.dp.my_pendings',
  subname: '(for Data operator)',
  icon: 'icon-pendings',
  roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Ownership',
    key: 'menu.dp.ownership',
    href: {
      name: 'ContPendingAssignmentsMe'
    },
    link: '/Requests/ContPendingAssignmentsMe',
    roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Access requests',
    key: 'menu.dp.access_requests',
    href: {
      name: 'ContTablesAccessRequested'
    },
    link: '/Requests/ContTablesAccessRequested',
    roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Change metadata requests',
    key: 'menu.dp.change_metadata',
    href: {
      name: 'ContTablesChangeMetadataRequested'
    },
    link: '/Requests/MetadataChangeRequested',
    roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Massive setup requests',
    key: 'menu.dp.massive_setup',
    href: {
      name: 'ContMassiveAccessRequest'
    },
    link: '/ContMassiveAccessRequest',
    roles: [ROLES_LIST.USER, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  name: 'Monitoring and Audit',
  key: 'menu.dp.monitoring_audit',
  subname: '',
  icon: 'icon-monitoring',
  roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.PLATFORM_STEWARD],
  subItems: [
  /* {
    name: 'Monitoring',
    key: 'menu.dp.monitoring',
    href: { name: 'ContMonitoring' },
    link: '/Monitoring/ContMonitoring',
    roles: [ROLES_LIST.ORG_DATA_STEWARD]
  },*/
  /* {
    name: 'BigQuery Consumption',
    key: 'menu.dp.bigquery_consumption',
    href: { name: 'ContDataDashboard' },
    link: '/Monitoring/ContDataDashboard',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.PLATFORM_STEWARD]
  },*/
  // Access Management report
  /* {
    name: 'INCA Metrics',
    key: 'menu.dp.inca_metrics',
    href: { name: 'INCAMetrics' },
    link: '/INCAMetrics',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.PLATFORM_STEWARD]
  },*/
  {
    name: 'Access Management Report',
    key: 'menu.dp.access_management',
    href: {
      name: 'AccessManagementReport'
    },
    link: '/AccessManagementReport',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.PLATFORM_STEWARD]
  }, {
    name: 'Tables Without Metadata Report',
    key: 'menu.dp.tables_without_metadata',
    href: {
      name: 'TablesWithoutMetadataReport'
    },
    link: '/TablesWithoutMetadataReport',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.PLATFORM_STEWARD]
  },
  /* {
    name: 'Operational Dashboard',
    key: 'menu.dp.profiling_dashboard',
    subname: '',
    href: { name: 'OperationalDashboard' },
    link: '/DataQuality/OperationalDashboard',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  },
  {
    name: 'Executive Dashboard',
    key: 'menu.dp.executive_dashboard',
    subname: '',
    href: { name: 'ExecutiveDashboard' },
    link: '/DataQuality/ExecutiveDashboard',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  },
  {
    name: 'Operational Dashboard',
    key: 'menu.dp.operational_dashboard',
    subname: '',
    href: { name: 'OperationalDashboard' },
    link: '/DataQuality/OperationalDashboard',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  },*/
  /* {
    name: 'Data Pipeline Lineage',
    key: 'menu.dp.data_pipeline',
    subname: '',
    checkDomain: true,
    href: { name: 'DopsDataLineage' },
    link: '/DopsDataLineage',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  },*/
  {
    name: 'Power BI Log',
    key: 'menu.dp.power_bi_log',
    subname: '',
    checkDomain: true,
    checkBI: true,
    href: {
      name: 'LogPowerBI'
    },
    link: '/LogPowerBI',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR]
  }, {
    name: 'Manage Power BI Log',
    key: 'menu.dp.manage_power_bi_log',
    subname: '',
    checkDomain: true,
    href: {
      name: 'AdminLogPowerBI'
    },
    link: '/AdminLogPowerBI',
    roles: [ROLES_LIST.ORG_DATA_STEWARD]
  }
  /* {
    name: 'Consumption KPI report',
    href: { name: 'ConsumptionReportKPI' },
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.PLATFORM_STEWARD]
  },*/
  /* {
    name: 'UserModuleAccess',
    key: 'menu.dp.user_module_access',
    subname: '',
    checkDomain: true,
    href: { name: '/UserModuleAccess' },
    link: '/UserModuleAccess',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }*/]
}, {
  name: 'Migrations',
  key: 'menu.dp.migrations',
  icon: 'mdi-swap-horizontal',
  subname: '',
  checkDomain: true,
  href: {
    name: 'Migrations'
  },
  link: '/Migrations',
  roles: [ROLES_LIST.ORG_DATA_STEWARD]
}, {
  name: 'My Tasks',
  key: 'menu.dp.my_tasks',
  icon: 'icon-tasks',
  subname: '',
  roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Table Assignments',
    key: 'menu.dp.table_assignments',
    subname: '',
    href: {
      name: 'ContAssignments'
    },
    link: '/Requests/ContAssignments',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Bulk load',
    key: 'menu.dp.bulk_load',
    subname: '',
    href: {
      name: 'ContLoadBulk'
    },
    link: '/Metadata/ContLoadBulk',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Download Metadata',
    key: 'menu.dp.download_metadata',
    subname: '',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    href: {
      name: 'ContMassiveDownload'
    },
    link: '/ContMassiveDownload'
  }, {
    name: 'Data Operator update',
    key: 'menu.dp.data_operator_update',
    subname: '',
    roles: [ROLES_LIST.ORG_DATA_STEWARD],
    href: {
      name: 'ContMassiveUpdate'
    },
    link: '/ContMassiveUpdate'
  }, {
    name: 'Add Tables with Cron',
    key: 'menu.dp.add_tables_cron',
    subname: '',
    href: {
      name: 'ContAddTablesWithCron'
    },
    link: '/Metadata/ContAddTablesWithCron',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'SyncTableFlagInca',
    key: 'menu.dp.sync_table_flag_inca',
    icon: 'mdi-sync',
    hidden: false,
    href: {
      name: 'SyncTableFlagInca'
    },
    link: '/Tables/SyncTableFlagInca',
    roles: ["support_developer"]
  }, {
    name: 'Tableau Objects',
    key: 'menu.dp.tableau_objects',
    subname: '',
    checkTableau: true,
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    subItems: [{
      name: 'Datasource Assignments',
      key: 'menu.dp.datasource_assignments',
      subname: '',
      href: {
        name: 'ContDatasourcesAssignment'
      },
      link: '/Metadata/ContDatasourcesAssignment',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    }, {
      name: 'Dashboard Assignments',
      key: 'menu.dp.dashboard_assignments',
      subname: '',
      href: {
        name: 'ContDashboardAssignment'
      },
      link: '/Metadata/ContDashboardAssignment',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    }, {
      name: 'Visualization Access',
      key: 'menu.dp.visualization_access',
      subname: '',
      href: {
        name: 'VisualizationUserAccess'
      },
      link: '/VisualizationUserAccess',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    }]
  }, {
    name: 'Power BI Objects',
    key: 'menu.dp.power_bi_objects',
    subname: '',
    checkBI: true,
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    subItems: [{
      name: 'Dataset Assignments',
      key: 'menu.dp.dataset_assignments',
      subname: '',
      href: {
        name: 'ContDatasetAssignment'
      },
      link: '/powerbi/ContDatasetAssignment',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    }, {
      name: 'Report Assignments',
      key: 'menu.dp.report_assignments',
      subname: '',
      href: {
        name: 'ContReportAssignment'
      },
      link: '/powerbi/ContReportAssignment',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    }, {
      name: 'Visualization Access',
      key: 'menu.dp.visualization_access_pbi',
      subname: '',
      href: {
        name: 'VisualizationUserAccessBi'
      },
      link: '/powerbi/VisualizationUserAccess',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    }]
  }, {
    name: 'Data Studio Objects',
    key: 'menu.dp.data_studio_objects',
    subname: '',
    checkDataStudio: true,
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    subItems: [{
      name: 'Report Assignments',
      key: 'menu.dp.report_assignments_gds',
      subname: '',
      href: {
        name: 'DSContReportAssignment'
      },
      link: '/datastudio/DSContReportAssignment',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
      exact: true
    }, {
      name: 'Datasource Assignments',
      key: 'menu.dp.datasource_assignments_gds',
      subname: '',
      href: {
        name: 'DSContDatasourceAssignment'
      },
      exact: true,
      link: '/datastudio/DSContDatasourceAssignment',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    }, {
      name: 'Visualization Access',
      key: 'menu.dp.visualization_access_gds',
      subname: '',
      href: {
        name: 'VisualizationUserAccessGDS'
      },
      link: '/datastudio/VisualizationUserAccessGDS',
      roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD],
      hidden: true
    }]
  }]
}, {
  name: 'All requests',
  icon: 'icon-requests',
  key: 'menu.dp.all_requests',
  subname: '(history)',
  href: {
    name: 'ContMyActivity'
  },
  link: '/Requests/ContMyActivity',
  roles: [ROLES_LIST.USER, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD]
  // roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD]
}, {
  name: 'Data Quality',
  key: 'menu.dp.data_quality',
  icon: 'icon-dquality',
  subname: '',
  roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD],
  hidden: true,
  subItems: [{
    name: 'Profiling Validation Types',
    key: 'menu.dp.profiling_validation',
    subname: '',
    href: {
      name: 'ProfilingValidationType'
    },
    link: '/ProfilingValidationType',
    roles: [ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Profiling History',
    key: 'menu.dp.profiling_history',
    subname: '',
    href: {
      name: 'ProfilingHistory'
    },
    link: '/ProfilingHistory',
    roles: [ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Profiling Score Parameters',
    key: 'menu.dp.profiling_score',
    subname: '',
    href: {
      name: 'ProfilingScoreParams'
    },
    link: '/ProfilingScoreParams',
    roles: [ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Profiling Dashboard',
    key: 'menu.dp.profiling_dashboard',
    subname: '',
    href: {
      name: 'ProfilingDashboard'
    },
    link: '/DataQuality/ProfilingDashboard',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  name: 'Data Quality (Dataplex)',
  key: 'menu.dp.data_quality_dataplex',
  icon: 'icon-dquality',
  subname: '',
  roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD],
  check_flag: 'data-platform/has_dataplex_active',
  subItems: [{
    name: 'Configuración',
    key: 'data_quality.menu.config',
    subname: '',
    href: {
      name: 'DataQualityConfigPage'
    },
    link: '/DataQuality/Config',
    roles: [ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Reglas',
    key: 'data_quality.menu.rules',
    subname: '',
    href: {
      name: 'DataQualityRulesPage'
    },
    link: '/DataQuality/Rules',
    roles: [ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Perfilamiento',
    key: 'data_quality.menu.profiling',
    subname: '',
    href: {
      name: 'DataQualityProfilingPage'
    },
    link: '/DataQuality/Profiling',
    roles: [ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Resumen de Perfilamientos',
    key: 'data_quality.menu.profiling_summary',
    subname: '',
    href: {
      name: 'DataProfilingSummaryPage'
    },
    link: '/DataQuality/ProfilingSummary',
    roles: [ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Calidad de Datos',
    key: 'data_quality.menu.quality',
    subname: '',
    href: {
      name: 'DataQualityPage'
    },
    link: '/DataQuality/Quality',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Reporte Control',
    key: 'data_quality.menu.control_dashboard',
    subname: '',
    href: {
      name: 'DataQualityControlDashboardPage'
    },
    link: '/DataQuality/ControlDashboardPage',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Reporte ejecutivo',
    key: 'data_quality.menu.executive_dashboard',
    subname: '',
    href: {
      name: 'DataQualityExecutiveDashboardPage'
    },
    link: '/DataQuality/ExecutiveDashboardPage',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Mantenimiento reportes',
    key: 'data_quality.menu.dashboard_maintenance',
    subname: '',
    href: {
      name: 'DataQualityDashboardMaintenancePage'
    },
    link: '/DataQuality/DashboardMaintenancePage',
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.DATAQUALITY_OPERATOR, ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  name: 'User profiles',
  key: 'menu.dp.user_profile',
  icon: 'icon-uprofile',
  subname: '',
  roles: [ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [{
    name: 'Area',
    key: 'menu.dp.up_area',
    subname: '',
    href: {
      name: 'ContDpArea'
    },
    link: '/ContDpArea',
    roles: [ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'User Profile',
    key: 'menu.dp.up_user_profile',
    subname: '',
    roles: [ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    href: {
      name: 'ContDpUserprofile'
    },
    link: '/ContDpUserprofile'
  }, {
    name: 'Table Details',
    key: 'menu.dp.up_table_details',
    subname: '',
    roles: [ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.ORG_DATA_STEWARD],
    href: {
      name: 'ContDpUserprofileTable'
    },
    link: '/ContDpUserprofileTable'
  }, {
    name: 'Profile Assignment',
    key: 'menu.dp.up_profile_assignments',
    subname: '',
    href: {
      name: 'ContDpProfileAssignment'
    },
    link: '/ContDpProfileAssignment',
    roles: [ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.ORG_DATA_STEWARD]
  }]
},
/* {
  name: 'Data Strategy',
  key: 'menu.dp.data_strategy',
  icon: 'icon-dataest',
  subname: '',
  roles: [ROLES_LIST.PRODUCT_OWNER, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.ASSESSMENT_USER, ROLES_LIST.ASSESSMENT_ADMIN],
  subItems: [
    {
      name: 'Strategy Managment',
      key: 'menu.dp.strategy_management',
      subname: '',
      href: { name: 'DataStrategy' },
      link: '/DataStrategy',
      roles: [ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD, ROLES_LIST.ORG_DATA_STEWARD]
    },
    {
      name: 'Assessment Report',
      key: 'menu.dp.evaluation_report',
      subname: '',
      href: { name: 'AssessmentReport' },
      link: '/AssessmentReport',
      roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.ASSESSMENT_USER, ROLES_LIST.ASSESSMENT_ADMIN]
    },
    {
      name: 'Admin Assessment Report',
      key: 'menu.dp.admin_evaluation_report',
      subname: '',
      href: { name: 'AdminAssessmentReport' },
      link: '/AdminAssessmentReport',
      roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.ASSESSMENT_ADMIN]
    }
  ]
},*/
/*{
  name: 'IA',
  key: 'menu.dp.artificial_intelligence',
  icon: 'mdi-brain',
  subname: '',
  roles: [
    ROLES_LIST.ORG_DATA_STEWARD,
    ROLES_LIST.BUSINESS_DATA_STEWARD,
    ROLES_LIST.AUDIENCE_USER,
    ROLES_LIST.AUDIENCE_ADMIN
  ],
  subItems: [
    {
      name: 'Generative Image',
      key: 'menu.dp.generative_image',
      subname: '',
      href: { name: 'GenerativeImage' },
      link: '/AITools/GenerativeImage',
      roles: [
        ROLES_LIST.ORG_DATA_STEWARD,
        ROLES_LIST.BUSINESS_DATA_STEWARD,
        ROLES_LIST.AUDIENCE_USER,
        ROLES_LIST.AUDIENCE_ADMIN
      ]
    }
  ]
},*/
/* {
  name: 'Dops Data Lineage',
  subname: '',
  roles: [ ROLES_LIST.DOPS_STEWARD ],
  href: { name: 'DopsDataLineage' }
},*/
/* {
  name: 'Data Governances Actions',
  icon: 'mdi-account-cog',
  subname: '',
  roles: [ROLES_LIST.ORG_DATA_STEWARD],
  subItems: [
    {
      name: 'Roles',
      href: { name: 'DataGovernanceRoles' },
      link: '/DataGovernanceRoles',
      roles: [ROLES_LIST.ORG_DATA_STEWARD]
    },
    {
      name: 'Business Domains',
      href: { name: 'BusinessDomain' },
      link: '/BusinessDomain',
      roles: [ROLES_LIST.ORG_DATA_STEWARD]
    }
  ]
},*/
{
  name: 'Business Glossary',
  key: 'menu.dp.business_glossary',
  icon: 'icon-bglossary',
  roles: [ROLES_LIST.USER, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD],
  subItems: [{
    name: 'Terms',
    key: 'menu.dp.business_glossary',
    href: {
      name: 'BusinessGlossary'
    },
    link: '/BusinessGlossary',
    roles: [ROLES_LIST.USER, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD]
  }, {
    name: 'Terms Load Bulk',
    key: 'menu.dp.bulk_load',
    href: {
      name: 'BusinessGlossaryLoadBulk'
    },
    link: '/BusinessGlossaryLoadBulk',
    roles: [ROLES_LIST.USER, ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD]
  }]
}, {
  name: 'Business Glossary',
  key: 'menu.dp.business_glossary',
  icon: 'mdi-link-box-variant',
  hidden: true,
  href: {
    name: 'admin_page'
  },
  link: '/BusinessGlossary',
  roles: [ROLES_LIST.ADMIN, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.BUSINESS_DATA_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD]
}];

/* Default data in the fields,for names,types and validation */
var DEFAULT_TPL_FIELDS = {
  ORGANIZATION: {
    name: 'org',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ALPHANUMBER']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  DOMAIN: {
    name: 'domain',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ALPHANUMBER']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  SUBDOMAIN: {
    name: 'subdomain',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ALPHANUMBER']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  OPERATOR: {
    name: 'operator',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['EMAIL_GENERAL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.ORG_DATA_STEWARD] // NOTE: has execptions in utils.fieldIsEdited for diference between search and assigmets for platform steward
  },
  PUBLIC: {
    name: 'public',
    type: 'boolValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['BOOLEAN']
    },
    enumValues: ['true', 'false'],
    // TODO: UI integrate
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  OFFICIAL_SOURCE: {
    name: 'official_source',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ALPHANUMBER']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  TECH_DATA_STEWARD: {
    name: 'tech_data_steward',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['EMAIL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  BUS_DATA_STEWARD: {
    name: 'bus_data_steward',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['EMAIL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  DATA_OWNER: {
    name: 'data_owner',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['EMAIL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  TECH_DATA_CUSTODIAM: {
    name: 'tech_data_custodiam',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['EMAIL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  TABLE_LOAD_LOGIC: {
    name: 'table_load_logic',
    type: 'stringValue',
    required: {
      isRequired: false
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  TABLES_RELATIONSHIP: {
    name: 'tables_relationship',
    type: 'stringValue',
    required: {
      isRequired: false
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD]
  },
  ENVIRONMENT: {
    name: 'env',
    type: 'enumValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ENVIRONMENT']
    },
    enumValues: ['prod', 'dev', 'test'],
    // Don't change order,FormMetadata.vue uses it on email message validation
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  DESCRIPTION: {
    name: 'description',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ALPHANUMBER']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  DESCRIPTION2: {
    name: 'description2',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['ALPHANUMBER']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  DESCRIPTION3: {
    name: 'description3',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['ALPHANUMBER']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  ZONE: {
    name: 'zone',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  AREA: {
    name: 'area',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  UPLOAD_PLATFORM: {
    name: 'upload_platform',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  UPLOAD_PROCESS: {
    name: 'upload_process',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  FINAL_TABLE: {
    name: 'final_table',
    type: 'boolValue',
    required: {
      isRequired: false
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  },
  AUTHORIZATION_TYPE: {
    name: 'authorization_type',
    type: 'stringValue',
    required: {
      isRequired: false
    },
    roles: [ROLES_LIST.PLATFORM_STEWARD, ROLES_RESOURCE_LIST.OWNER]
  }
};

/* Default data in the columns,for names,types and validation */
var DEFAULT_TPL_COLUMNS = {
  DATA_ELEMENT_NAME: {
    name: 'data_element_name',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    }
  },
  BUSINESS_DEFINITION: {
    name: 'business_definition',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    }
  },
  LENGTH: {
    name: 'length',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    }
  },
  NULL: {
    name: 'null',
    type: 'boolValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['BOOLEAN']
    }
  },
  PRIMARY_KEY: {
    name: 'primary_key',
    type: 'boolValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['BOOLEAN']
    }
  },
  SENSITIVE: {
    name: 'sensitive',
    type: 'boolValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['BOOLEAN']
    }
  },
  TRANSFORMATION_LOGIC: {
    name: 'transformation_logic',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    }
  },
  TYPE: {
    name: 'type',
    type: 'stringValue',
    required: {
      isRequired: true,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    }
  },
  VALID_VALUES: {
    name: 'valid_values',
    type: 'stringValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['ANY_FILL']
    }
  },
  ENCRYPTED: {
    name: 'encrypted',
    type: 'boolValue',
    required: {
      isRequired: false,
      validation: PATTERNS_VALIDATION['BOOLEAN']
    }
  },
  COLUMN_LOAD_LOGIC: {
    name: 'column_load_logic',
    type: 'stringValue',
    required: {
      isRequired: false
    }
  }
};

// only localbrowser view (not is retive for backend)
/* to display only local browser view (not relative to backend) */
var UI_DATA_PERMISIONS = {
  COLUMN_FIELD: {
    name: 'columnField',
    roles: [ROLES_RESOURCE_LIST.OWNER, ROLES_LIST.PLATFORM_STEWARD]
  },
  LOGS_FIELD: {
    name: 'logsField',
    roles: [ROLES_RESOURCE_LIST.OWNER, ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.PLATFORM_STEWARD]
  }
};
var UI_CUSTOM_PERMISIONS = {
  SYNC_TABLE: {
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.PLATFORM_STEWARD]
  }
};
var firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID
};
var firebaseDataOperationConfig = {
  apiKey: 'AIzaSyAfBWxHynvI7fWg4pmM6G4w5XjY6D7yGU0',
  authDomain: 'silent-matter-270218.firebaseapp.com',
  projectId: 'silent-matter-270218',
  storageBucket: 'silent-matter-270218.appspot.com',
  messagingSenderId: '947655304508',
  appId: '1:947655304508:web:cb60543dc2323c91802a39',
  measurementId: 'G-G0V11SYCJ3'
};
var TAG_QUERIES = {
  ALL_TABLES: 'type=(table)',
  //
  MY_TABLES: 'tag:{project_id}.tpl_tables.operator:${email}',
  // for replace email
  TABLES_RELATED_BT: '(tag:{project_id}.tpl_tables.env=prod AND tag:{project_id}.tpl_columns.business_term AND tag:{project_id}.tpl_columns.business_term:${business_term})',
  // for replace business_term
  ALL_WITHOUT_OWNER: '-tag:{project_id}.tpl_tables.env=prod tag:operator',
  // TODO: change var name is for assignment
  ALL_WITH_OWNER: 'tag:{project_id}.tpl_tables.env=prod tag:{project_id}.tpl_tables.operator' // TODO: change name is for search list
};
var TAG_QUERIES_ALL = {
  ALL_TABLES: 'type=(table)',
  //
  MY_TABLES: 'tag:{project_id}.tpl_tables.operator:${email}',
  // for replace email
  TABLES_RELATED_BT: '(tag:{project_id}.tpl_columns.business_term AND tag:{project_id}.tpl_columns.business_term:${business_term})',
  // for replace business_term
  ALL_WITHOUT_OWNER: '-tag:{project_id}.tpl_tables.env=prod',
  // TODO: change var name is for assignment
  ALL_WITH_OWNER: 'tag:{project_id}.tpl_tables.env=prod tag:{project_id}.tpl_tables.operator' // TODO: change name is for search list
};
var ACCESS_TYPE_FLOW = {
  ACCESS: 'ACCESS',
  CHANGE_METADATA: 'CHANGE_METADATA',
  APPROVE_OWNER: 'APPROVE_OWNER',
  INCLUDED: 'INCLUDED',
  NOT_INCLUDED: 'NOT_INCLUDED',
  ASSIGN_DATA_OPERATOR: 'ASSIGN_DATA_OPERATOR',
  VIEWER_ONLY: 'VIEWER_ONLY'
};
var envConfig = {
  defaultPathRedirect: '/Home',
  LOG_LIMIT: '20',
  // is string
  timeWaitForApi: 3000,
  // milliseconds
  pagintaionSize: 10,
  pagintaionTagsSize: 500,
  MAX_RETRIES: 15,
  DELAY_RETRIES: 500,
  TABLE_TAGS_LIMIT: 100,
  svc_apis_host: process.env.VUE_APP_SVC_APIS_HOST,
  svc_apis_gtw: process.env.VUE_APP_API_GTW
};
var TYPE_CHANGE_METADA = {
  PREVIEW_OWNER: 'PREVIEW_OWNER',
  // Use only for preview owner
  VIEWER_ONLY: 'VIEWER_ONLY',
  UPDATE: 'UPDATE',
  // API used
  OWENER_FLOW: 'OWENER_FLOW',
  // API used
  CHANGE_REQUEST: 'CHANGE_REQUEST' // API used
};
var textsDefaul = {
  NOT_TABLES: 'You do not have tables',
  NOT_ACCESS: 'You do not have access',
  NOT_DATASOURCES: 'You do not have any datasource',
  NOT_WORKBOOKS: 'You do not have any dashboard',
  NOT_DATASETS: 'You do not have any dataset',
  NOT_REPORTS: 'You do not have any report',
  NOT_FOUND: 'Nothing was found',
  LOADING: 'Loading...',
  NOT_REQUEST: 'You don´t have requests',
  NOT_HISTORY_LOGS: 'No history logs were found'
};
var LOG_TYPE = {
  METADATA: 'metadata',
  OBJECT: 'object',
  CRON: 'CRON'
};
var METADATA_IMAGE_FORMAT = ['.png', '.jpg', '.pdf'];
var METADATA_DOCUMENT_FORMAT = ['.docx', '.xlsx', '.pptx', '.pdf'];
var METADATA_EMAIL_FORMAT = ['.eml', '.ics', '.vcf', '.zip'];
var METADATA_FILE_FORMAT = METADATA_IMAGE_FORMAT.concat(METADATA_DOCUMENT_FORMAT);
var ACCES_REQUEST_FILE_FORMAT = METADATA_IMAGE_FORMAT.concat(METADATA_EMAIL_FORMAT);
var ALL_TABLES_OPTION = 'All';
var ACCESS_SERVICE_ACCOUNT_INPUT = [ROLES_LIST.PLATFORM_STEWARD, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD];
var LIST_DOMAINS = ['bluetab.net', 'gmail.com', 'ifxp.pe', 'inside.com.pe', 'intercorp.com.pe', 'oechsle.pe', 'somosoh.pe'];

/**
 * Dominios asociados a Financiera OH! / IFXP.
 * Se usa para activar validaciones especiales (isFOH).
 * Cuando la migración de @somosoh.pe → @ifxp.pe finalice,
 * basta con eliminar 'somosoh.pe' de este array.
 */
var FOH_DOMAINS = ['somosoh.pe', 'ifxp.pe'];

/**
 * Verifica si un dominio pertenece a Financiera OH! / IFXP.
 * @param {string} domain - Dominio del usuario (ej: 'somosoh.pe')
 * @returns {boolean}
 */
function isFOHDomain(domain) {
  return FOH_DOMAINS.includes(domain);
}
var LIST_ROLES = Object.values(ROLES_LIST).slice(2);
var NEW_BUSINESS_TERM = {
  type: 'Term',
  kdomain: '',
  ksubdomain: '',
  kbusiness_term: '',
  business_term: '',
  definition: '',
  update_date: '',
  values: [],
  classification: [],
  also_known_as: '',
  accountable: '',
  critical: false,
  status: true,
  relationship: {
    contains: [],
    is_contained_in: [],
    is_a_type_of: [],
    related_term: [],
    is_a_related_term_from: [],
    is_calculated_from: []
  },
  related_objects: [],
  params: ''
};
var BUCKET_DIRECTORY_TYPES = {
  FILES: 'FILES',
  TABLES: 'TABLES',
  WORKBOOKS: 'WORKBOOKS',
  WORKBOOKS_RAW: 'WORKBOOKS_RAW',
  DATASOURCES: 'DATASOURCES',
  DATASOURCES_RAW: 'DATASOURCES_RAW',
  DATASETS: 'DATASETS',
  DATASETS_RAW: 'DATASETS_RAW',
  REPORTS: 'REPORTS',
  REPORTS_RAW: 'REPORTS_RAW'
};
var ENVIRONMENT_FLOW = {
  DEV: 'dev',
  TEST: 'test',
  PROD: 'prod'
};
var TYPE_ELEMENTS = {
  RANGE: 'range',
  SELECT: 'select',
  MULTI_SELECT: 'multi-select',
  INPUT: 'input',
  BOOLEAN: 'bool',
  SELECT_RANGE: 'select-range',
  INPUT_COMPARE: 'input-compare',
  MASKED_MULTI_SELECT: 'masked-multi-select'
};
var ARRAY_TYPE_ELEMENTS = [TYPE_ELEMENTS.RANGE, TYPE_ELEMENTS.SELECT, TYPE_ELEMENTS.MULTI_SELECT, TYPE_ELEMENTS.MASKED_MULTI_SELECT, TYPE_ELEMENTS.INPUT, TYPE_ELEMENTS.BOOLEAN, TYPE_ELEMENTS.SELECT_RANGE, TYPE_ELEMENTS.INPUT_COMPARE];
var GA_EVENTS = {
  LOGIN: 'login',
  LOGOUT: 'logout',
  VIEW_ITEM_LIST: 'view_item_list',
  SELECT_ITEM: 'select_item',
  PREVIEW: 'previsualizar',
  SAVE: 'guardar',
  CLICK_REPORT: 'click_report',
  SELECT_MENU: 'select_menu',
  HELP_CENTER_VIEW: 'help_center_view',
  VIEW_VIDEO_HC: 'view_video_hc',
  OWNERSHIP: 'ownership',
  ACCESS: 'access_request',
  CHANGE_METADATA: 'change_metadata',
  MASSIVE_REQUEST_MANAGEMENT: 'massive_request_management',
  ASSIGN_OPERATOR: 'assign_operator',
  BULK_UPLOAD: 'bulk_load',
  DOWNLOAD_MASSIVE_METADATA: 'download_massive_metadata',
  DOWNLOAD_METADATA: 'download_metadata',
  ACCESS_REQUEST_MANAGEMENT: 'access_request_management',
  CHANGE_METADATA_MANAGEMENT: 'change_metadata_management',
  SYNC_TABLE: 'sync_table',
  CREATE_SEGMENT: 'create_segment',
  EDIT_SEGMENT: 'edit_segment',
  CREATE_AUDIENCE: 'create_audience',
  EDIT_AUDIENCE: 'edit_audience',
  OWN_DATA: 'own_data',
  CREATE_SANDBOX: 'create_sandbox',
  SANDBOX_REQUEST_MANAGEMENT: 'sandbox_request_management',
  EDIT_ATTRIBUTE_CATEGORY: 'edit_attribute_category',
  EXPORT_AUDIENCE: 'export_audience',
  ADD_BASE_INCA: 'add_base_inca',
  DOWNLOAD_REPORT: 'download_report',
  ADD_BTERM_TABLE: 'add_bterm_table',
  DOWNLOAD_GLOSSARY: 'download_glossary',
  VIEW_METADATA: 'view_metadata'
};
var TYPSE_SENSE_TYPE_OBJECTS = {
  TABLE: 'table',
  VIEW: 'view',
  TERM: 'term',
  TBL_DATASOURCE: 'tbl_datasource',
  TBL_DASHBOARD: 'tbl_dashboard',
  PBI_DATASET: 'pbi_dataset',
  PBI_REPORT: 'pbi_report',
  GDS_REPORT: 'gds_report',
  GDS_DATASOURCE: 'gds_datasource'
};
var ORGS = [{
  code: '000',
  empresa: 'Interbank',
  category: 'Financiera'
}, {
  code: '011',
  empresa: 'Oechsle',
  category: 'Retail'
}, {
  code: '012',
  empresa: 'Financiera Oh!',
  category: 'Retail'
}, {
  code: '015',
  empresa: 'Real Plaza',
  category: 'Retail'
}, {
  code: '024',
  empresa: 'Promart',
  category: 'Retail'
}, {
  code: '032',
  empresa: 'Intercorp',
  category: 'Growth'
}, {
  code: '033',
  empresa: 'NGR',
  category: 'Growth'
}, {
  code: '074',
  empresa: 'Farmacias Peruanas',
  category: 'Retail'
}, {
  code: '010',
  empresa: 'Supermercados Peruanos',
  category: 'Retail'
}, {
  code: '005',
  empresa: 'Aviva',
  category: 'Growth'
}, {
  code: '022',
  empresa: 'Intercorp Retail',
  category: 'Retail'
}, {
  code: '019',
  empresa: 'Urbi',
  category: 'Growth'
}, {
  code: '021',
  empresa: 'Innova Schools',
  category: 'Educación'
}];
var PERIODS = {
  ONE_DAY: '1_DAY',
  ONE_WEEK: '1_WEEK',
  BIWEEKLY: '15_DAY',
  ONE_MONTH: '1_MONTH',
  SIX_MONTH: '6_MONTH'
};
var DATAPLEX_STATES = {
  STATE_UNSPECIFIED: 'NO ESPECIFICADO',
  // (0) The DataScanJob state is unspecified.
  RUNNING: 'EJECUTANDO',
  // (1) The DataScanJob is running.
  CANCELING: 'CANCELANDO',
  // (2) The DataScanJob is canceling.
  CANCELLED: 'CANCELADO',
  // (3) The DataScanJob cancellation was successful.
  SUCCEEDED: 'ÉXITO',
  // (4) The DataScanJob completed successfully.
  FAILED: 'FALLÓ',
  // (5) The DataScanJob is no longer running due to an error.
  PENDING: 'PENDIENTE' // (7) The DataScanJob has been created but not started to run yet.
};
var TYPES_EXPORT_ATTRIBUTES = [{
  value: 1,
  text: 'Audiencias'
}, {
  value: 2,
  text: 'Base ID'
}, {
  value: 3,
  text: 'Base ID con Variables'
}, {
  value: 4,
  text: 'Transformados'
}];
var STATUS_ATTRIBUTES = [{
  value: 1,
  text: 'Solicitado'
}, {
  value: 2,
  text: 'Error'
}, {
  value: 3,
  text: 'Aprobado'
}, {
  value: 4,
  text: 'Finalizado'
}, {
  value: 5,
  text: 'Guardado'
}, {
  value: 6,
  text: 'Creando'
}, {
  value: 7,
  text: 'Rechazado'
}, {
  value: 8,
  text: 'Actualizando'
}, {
  value: 9,
  text: 'Observado'
}, {
  value: 10,
  text: 'Vencido'
}, {
  value: 11,
  text: 'Registrado'
}, {
  value: 12,
  text: 'En ejecución'
}, {
  value: 13,
  text: 'Activo'
}, {
  value: 14,
  text: 'Ejecutado'
}, {
  value: 15,
  text: 'Publicando'
}, {
  value: 16,
  text: 'En Revisión'
}, {
  value: 17,
  text: 'Enviado'
}, {
  value: 18,
  text: 'Desplegando'
}, {
  value: 19,
  text: 'Desplegado'
}, {
  value: 20,
  text: 'Eliminado'
}, {
  value: 21,
  text: 'Inactivo'
}];
var ENVIRONMENT_ATTRIBUTES = [{
  value: 'prd',
  text: 'Producción'
}, {
  value: 'dev',
  text: 'Desarrollo'
}, {
  value: 'all',
  text: 'Todos'
}];
var SEGMENT_TYPE_NAME = [{
  value: 'SEGMENT_CONTACT',
  text: 'Contacto'
}, {
  value: 'SEGMENT_ADVERTISING',
  text: 'Advertising'
}];
var CAMPAIGN = {
  VARIABLE_TYPE: {
    TEXT: 2,
    SELECT: 3,
    TABLE: 7,
    NUMERIC: 1
  }
};
var BIGQUERY_TYPES = ['STRING', 'BYTES', 'INTEGER', 'FLOAT', 'NUMERIC', 'BIGNUMERIC', 'BOOLEAN', 'TIMESTAMP', 'DATE', 'TIME', 'DATETIME', 'GEOGRAPHY', 'RECORD', 'RANGE', 'JSON'];
var MODULE_ID = {
  'menu.dp.initial_setup': 'menu_dp_initial_setup',
  'menu.dp.my_objects': 'menu_dp_my_objects',
  'menu.dp.my_pendings': 'menu_dp_my_pendings',
  'menu.dp.ownership': 'menu_dp_ownership',
  'menu.dp.access_requests': 'menu_dp_access_requests',
  'menu.dp.change_metadata': 'menu_dp_change_metadata',
  'menu.dp.massive_setup': 'menu_dp_massive_setup',
  'menu.dp.monitoring_audit': 'menu_dp_monitoring_audit',
  'menu.dp.access_management': 'menu_dp_access_management',
  'menu.dp.tables_without_metadata': 'menu_dp_tables_without_metadata',
  'menu.dp.power_bi_log': 'menu_dp_power_bi_log',
  'menu.dp.manage_power_bi_log': 'menu_dp_manage_power_bi_log',
  'menu.dp.my_tasks': 'menu_dp_my_tasks',
  'menu.dp.table_assignments': 'menu_dp_table_assignments',
  'menu.dp.bulk_load': 'menu_dp_bulk_load',
  'menu.dp.download_metadata': 'menu_dp_download_metadata',
  'menu.dp.data_operator_update': 'menu_dp_data_operator_update',
  'menu.dp.add_tables_cron': 'menu_dp_add_tables_cron',
  'menu.dp.tableau_objects': 'menu_dp_tableau_objects',
  'menu.dp.datasource_assignments': 'menu_dp_datasource_assignments',
  'menu.dp.dashboard_assignments': 'menu_dp_dashboard_assignments',
  'menu.dp.visualization_access': 'menu_dp_visualization_access',
  'menu.dp.power_bi_objects': 'menu_dp_power_bi_objects',
  'menu.dp.dataset_assignments': 'menu_dp_dataset_assignments',
  'menu.dp.report_assignments': 'menu_dp_report_assignments',
  'menu.dp.visualization_access_pbi': 'menu_dp_visualization_access_pbi',
  'menu.dp.data_studio_objects': 'menu_dp_data_studio_objects',
  'menu.dp.report_assignments_gds': 'menu_dp_report_assignments_gds',
  'menu.dp.datasource_assignments_gds': 'menu_dp_datasource_assignments_gds',
  'menu.dp.visualization_access_gds': 'menu_dp_visualization_access_gds',
  'menu.dp.all_requests': 'menu_dp_all_requests',
  'menu.dp.data_quality': 'menu_dp_data_quality',
  'menu.dp.profiling_validation': 'menu_dp_profiling_validation',
  'menu.dp.profiling_history': 'menu_dp_profiling_history',
  'menu.dp.profiling_score': 'menu_dp_profiling_score',
  'menu.dp.profiling_dashboard': 'menu_dp_profiling_dashboard',
  'menu.dp.data_quality_dataplex': 'menu_dp_data_quality_dataplex',
  'data_quality.menu.config': 'data_quality_menu_config',
  'data_quality.menu.rules': 'data_quality_menu_rules',
  'data_quality.menu.profiling': 'data_quality_menu_profiling',
  'data_quality.menu.quality': 'data_quality_menu_quality',
  'menu.dp.user_profile': 'menu_dp_user_profile',
  'menu.dp.up_area': 'menu_dp_up_area',
  'menu.dp.up_user_profile': 'menu_dp_up_user_profile',
  'menu.dp.up_table_details': 'menu_dp_up_table_details',
  'menu.dp.up_profile_assignments': 'menu_dp_up_profile_assignments',
  'menu.dp.artificial_intelligence': 'menu_dp_artificial_intelligence',
  'menu.dp.generative_image': 'menu_dp_generative_image'
};
module.exports = {
  textsDefaul: textsDefaul,
  firebaseConfig: firebaseConfig,
  firebaseDataOperationConfig: firebaseDataOperationConfig,
  envConfig: envConfig,
  TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
  ROLES_LIST: ROLES_LIST,
  DEFAULT_TPL_FIELDS: DEFAULT_TPL_FIELDS,
  LOG_TYPE: LOG_TYPE,
  DEFAULT_TPL_COLUMNS: DEFAULT_TPL_COLUMNS,
  TAG_QUERIES: TAG_QUERIES,
  TAG_QUERIES_ALL: TAG_QUERIES_ALL,
  ROLES_RESOURCE_LIST: ROLES_RESOURCE_LIST,
  UI_DATA_PERMISIONS: UI_DATA_PERMISIONS,
  UI_CUSTOM_PERMISIONS: UI_CUSTOM_PERMISIONS,
  ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
  IFRAMES: IFRAMES,
  PATTERNS_VALIDATION: PATTERNS_VALIDATION,
  MENU_DICT: MENU_DICT,
  METADATA_FILE_FORMAT: METADATA_FILE_FORMAT,
  METADATA_IMAGE_FORMAT: METADATA_IMAGE_FORMAT,
  ACCES_REQUEST_FILE_FORMAT: ACCES_REQUEST_FILE_FORMAT,
  ALL_TABLES_OPTION: ALL_TABLES_OPTION,
  ACCESS_SERVICE_ACCOUNT_INPUT: ACCESS_SERVICE_ACCOUNT_INPUT,
  LIST_ROLES: LIST_ROLES,
  LIST_DOMAINS: LIST_DOMAINS,
  NEW_BUSINESS_TERM: NEW_BUSINESS_TERM,
  BUCKET_DIRECTORY_TYPES: BUCKET_DIRECTORY_TYPES,
  ENVIRONMENT_FLOW: ENVIRONMENT_FLOW,
  TYPE_ELEMENTS: TYPE_ELEMENTS,
  ARRAY_TYPE_ELEMENTS: ARRAY_TYPE_ELEMENTS,
  TYPSE_SENSE_TYPE_OBJECTS: TYPSE_SENSE_TYPE_OBJECTS,
  GA_EVENTS: GA_EVENTS,
  ORGS: ORGS,
  PERIODS: PERIODS,
  DATAPLEX_STATES: DATAPLEX_STATES,
  TYPES_EXPORT_ATTRIBUTES: TYPES_EXPORT_ATTRIBUTES,
  STATUS_ATTRIBUTES: STATUS_ATTRIBUTES,
  ENVIRONMENT_ATTRIBUTES: ENVIRONMENT_ATTRIBUTES,
  CAMPAIGN: CAMPAIGN,
  SEGMENT_TYPE_NAME: SEGMENT_TYPE_NAME,
  BIGQUERY_TYPES: BIGQUERY_TYPES,
  FOH_DOMAINS: FOH_DOMAINS,
  isFOHDomain: isFOHDomain
};